import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import Menu from './Menu';
import Hamburger from './Hamburger';
import logo from '../images/logo.svg';
import logoMobile from '../images/logo.svg';
import Alert from 'react-bootstrap/Alert';
import MenuMobile from './MenuMobile';
import Sticky from 'react-sticky-el';
// import * as Scroll from 'react-scroll';
import { Link as ScrollLink, Events } from 'react-scroll';
import { globalHistory as history } from '@reach/router';
import { PATHS } from '../utils/urls';
import { categoriesList } from '../utils/categories';
import SearchContainer from './SearchContainer';

// let focusElement = document.getElementById("name");
// console.log("Focus Element = " + focusElement)

//announcement bar
function AlertDismissible(props) {

	const { location } = history;


	const [show, setShow] = useState(true);

	const sourcePage = "/blog/company-updates/charthop-acquires-gather/";

	if (location.pathname === sourcePage) {
	} else {
		if (show) {
			return (
				<Alert variant="secondary" onClose={() => setShow(false)} dismissible className="bg-secondary">
					<div className="container">	
					<a href={sourcePage}><p className="text-md-center"> 
                       🚀 ChartHop acquires Gather to further enhance the employee experience <u className="font-weight-bold" >GET THE STORY</u></p>
					</a> 
					</div>
				</Alert>
			);
		}
	}
	return '';
}

const Header = (props) => {

	const [menuActive, setMenuActive] = useState(false);
	const [focusTarget, setFocusTarget] = useState(false);
	const [categoryParam, setCategoryParam] = useState([]);
	const [searchParam, setSearchParam] = useState([]);


	useEffect(() => {
		setFocusTarget(document.querySelector(".longFormParentContainer .focusInputElement"))
		const url = window.location.href;
		let queryParams = url.split("?")[1]?.split("&").map(property => property.split("=")) || [];
		if (queryParams.length > 0) {
			queryParams.forEach(param => {
				if(param[0] === "categories") {
					setCategoryParam(param[1]);
				}
				if(param[0] === "query") {
					setSearchParam(decodeURIComponent(param[1]));					
				}
			})
		}
		Events.scrollEvent.register('end', function (to, element) {
			if (element.id === 'request-demo') {
				var inputFocus = document.querySelector(".longFormParentContainer .focusInputElement");
				inputFocus.focus();
			}
			Events.scrollEvent.remove('end');
		});

		var demoLink = document.querySelector("#demo-link")
		// console.log("Demo link: " + demoLink)

		demoLink.onClick = function () {
			console.log("clicked");
		}
	}, [])

	const toggleMenu = () => {
		setMenuActive(!menuActive);
	};

	const focusFirstName = () => {
		document.querySelector(".longFormParentContainer .focusInputElement").focus();
		document.querySelector(".longFormParentContainer .focusInputElement").select();
	}

	const toggleMenuClose = () => {
		const menuToggle = document.querySelector("#main-menu-mobile");
		const menuIcon = document.querySelector("#toggle-main-menu-mobile");

		// console.log(menuIcon);
		menuToggle.classList.remove("open");
		menuIcon.classList.remove("is-active");
		// handleClick = event => event.target.classList.add('click-state');
	}


	const RequestDemo = () => {

		if (!focusTarget) {
			return <Link to="/#request-demo" id="demo-link" className="button primary demo-link smoothScrollLink"><span className="d-none d-sm-inline" id="demo-a">GET LIVE DEMO</span></Link>

		} else {
			return <ScrollLink onClick={toggleMenuClose} to="request-demo" smooth={true} offset={-70} duration={2500} id="demo-link" className="button primary demo-link smoothScrollLink"><span className="d-none d-sm-inline " id="demo-a">GET LIVE DEMO </span></ScrollLink>
		}
	}
	return (
		<div className="header" id="headerNavigation">

			<div className="blogBanner">
				<AlertDismissible />
			</div>

			<Sticky className="sticky-wrapper">
				<div className="container">
					<div className="headerNavigation" >
						<div className="spacing">
							<div className="logo">
								<Link to={PATHS.HOME}>
									<img alt="ChartHop Homepage" src={logo} />
								</Link>
							</div>
							<div className="logo-mobile">
								<Link to={PATHS.HOME}>
									<img alt="ChartHop Homepage" className="mt-1 mb-1" src={logoMobile} />
								</Link>
							</div>

							<MenuMobile active={menuActive} />
							<Menu />
							<div className="header-cta">

								{RequestDemo()}
								<a href="https://app.charthop.com/" className="button secondary" rel="noopener noreferrer">SIGN IN</a>
								<Hamburger toggleMenu={toggleMenu} />
							</div>
						</div>
						{props.showSearchBar && <SearchContainer arrayToSearch={[]} categories={categoriesList} hotRefresh={false} isMobile={true} searchQuery={searchParam} categoryQuery={decodeURI(categoryParam)} />}
					</div>

				</div>
			</Sticky>
			{/* <div className="pb-md-4"></div> */}
		</div>
	);
}
export default Header;
